import { render, staticRenderFns } from "./ZxFawuZhixingjinduForm.vue?vue&type=template&id=35bd3816&scoped=true&"
import script from "./ZxFawuZhixingjinduForm.vue?vue&type=script&lang=js&"
export * from "./ZxFawuZhixingjinduForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd3816",
  null
  
)

export default component.exports